
import {Routes, Route, useParams, Link} from "react-router-dom";
import Header from "../../layouts/Header";
import Icon from "../../components/icon";
import Listing from "./Listing";
import Edit from "./Edit";
import Create from "./Create";



const RoleManager = () => {
    const {id} = useParams()

    return (
        <>
            <Header
                icon="role"
                title="Role Manager"
                buttons={[
                    !id && window.location.pathname !== '/roles/new' &&
                    <Link to={'new'} className="btn btn-sm btn-primary">
                        <Icon name="plus"/> <span>Create</span>
                    </Link>,
                ]}
            />
            <Routes>
                <Route index element={<Listing/>}/>
                <Route path="new" element={<Create/>}/>
                <Route path=":id" element={<Edit id={id}/>}/>
            </Routes>
        </>
    )
}

export default RoleManager